import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useSelector } from "react-redux";
import ServiceMobileLiveStatus from "./ServiceMobileLiveStatus";
import ServiceMoblieLotDetail from "./ServiceMoblieLotDetail";

function ServiceMobileSingleLotAnimation({ singleAuctionData }) {
  const { profile } = useSelector((state) => state?.profileStore);
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  };
  return (
    <>
      <Swiper
        pagination={pagination}
        modules={[Pagination]}
        className="mySwiper"
      >
        {singleAuctionData?.offers?.map((item, index) => (
          <SwiperSlide key={item.id || index}>
            <div className="flex column" style={{ gap: "3px" }}>
              <ServiceMobileLiveStatus item={item} profile={profile} />
              <ServiceMoblieLotDetail
                singleAuctionData={singleAuctionData}
                selectedLot={index}
              />
            </div>
          </SwiperSlide>
        ))}
        <p style={{ position: "absolute", bottom: 35 }}>
          Select the Lot number to navigate directly to the Lot.
        </p>
      </Swiper>
    </>
  );
}

export default ServiceMobileSingleLotAnimation;
